import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { ContractVersionsPageContractVersionCompensationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import {
  CompensationTypes,
  additionalCompensationType,
  getDescriptionByType,
} from 'modules/contracts/lib/additionalCompensations'

interface Props {
  compensation: ContractVersionsPageContractVersionCompensationFragment
  legalEntityCurrency: string
}

const CompensationItem = ({ compensation, legalEntityCurrency }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()

  const compensationType = additionalCompensationType(compensation.compensationType)
  const isFixed = compensationType === CompensationTypes().fixed?.toLowerCase()
  const taxonomy = compensation.taxonomy

  return (
    <List.Item>
      <Box gap="s8">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Text size="200" weight="normal" color="grey800">
            {taxonomy?.name ?? ''}
          </Text>
          {isFixed && (
            <Text size="200" weight="normal" color="grey800">
              {compensationType}
            </Text>
          )}
          {compensation.description && (
            <ContractTooltip information={compensation.description} icon="info-circle-line" />
          )}
        </Box>
        <Box flexDirection="row" gap="s4">
          <Text.Normal capitalize weight="medium" size="200" color="grey1000">
            {getDescriptionByType({
              compensation,
              legalEntityCurrency,
              locale,
            })}
          </Text.Normal>
        </Box>
      </Box>
    </List.Item>
  )
}

export default observer(CompensationItem)
